import React from 'react';

export default function CloseThemesModalButton({ close }) {
  return (
    <span onClick={close}>
      <i className="icon icon-hg-cross" />
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Places/CloseThemesModalButton.jsx